import React, { useEffect, useMemo, useState } from "react";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import TableContainer, { DEFAULT_SORTBY } from "../../components/Common/TableContainer";
import { get, del } from "./../../helpers/api_helper";
import { useNavigate, Link } from "react-router-dom";
import { CUSTOMER_LIST, DELETE_CUSTOMER } from "../../helpers/url_helper";
import toastr from "toastr";
import "toastr/build/toastr.min.css"; // Make sure this is imported for styling
import customerColumns from "./../../components/Columns/CustomerColumns";
import EditCustomerModal from "./EditCustomerModal";

const Customers = () => {
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    try {
      const authUser = JSON.parse(localStorage.getItem("authUser"));
      const role = Number(authUser?.user?.role);
      setIsAdmin(role === 1);
    } catch {
      setIsAdmin(false);
    }
  }, []);
  const breadcrumbItems = [
    { title: "ValSabji", link: "/" },
    { title: "customers", link: "#" },
  ];

  const [customers, setCustomers] = useState([]);
  const [pageIndex, setPageIndex] = useState(1); // Starts at 0
  const [pageSize, setPageSize] = useState(200); // Default page size
  const [totalPages, setTotalPages] = useState(0);
  const [sortBy, setSortBy] = useState(DEFAULT_SORTBY);
  const [searchText, setSearchText] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  async function getCustomersList(page, size, sort = [], search = "") {
    const sortKey = sort[0]?.id;
    const sortBy = sort[0]?.desc ? "desc" : "asc";
    return await get(CUSTOMER_LIST, {
      params: {
        page,
        size,
        sortKey,
        sortBy,
        search,
      },
    });
  }

  const fetchCustomers = async (
    page = 1,
    size = 200,
    sortBy = [],
    searchText
  ) => {
    try {
      const response = await getCustomersList(page, size, sortBy, searchText); // Assuming your API takes page & size
      const { items, totalPages } = response.data;

      setCustomers(items);
      setTotalPages(totalPages);
    } catch (error) {
      console.error("Failed to fetch customers:", error);
    }
  };

  const handleSearchChange = (text) => {
    setPageIndex(1);
    setSearchText(text);
  };

  useEffect(() => {
    fetchCustomers(pageIndex, pageSize, sortBy, searchText);
  }, [pageIndex, pageSize, sortBy, searchText]);

  const handleEdit = (customer) => {
    setSelectedCustomer(customer);
    setEditModalOpen(true);
  };

  const [editModalOpen, setEditModalOpen] = useState(false);

  const handleDelete = (customer) => {
    setSelectedCustomer(customer); // Set the customer to be deleted
    setModalOpen(true); // Open the modal
  };

  const toggleModal = () => {
    setModalOpen(!modalOpen); // Close the modal
  };

  const confirmDelete = async () => {
    try {
      await del(DELETE_CUSTOMER(selectedCustomer.ul_id)); // Delete the customer
      toastr.success("Customer deleted successfully!");
      fetchCustomers(pageIndex, pageSize, sortBy, searchText);
    } catch (error) {
      console.error(
        "Failed to delete customer:",
        error.response?.data || error.message
      );
      toastr.error("Something went wrong while deleting.");
    }
    setModalOpen(false); // Close the modal after the operation
  };

  const columns = useMemo(
    () =>
      customerColumns(
        isAdmin ? handleEdit : null,
        isAdmin ? handleDelete : null
      ),
    [isAdmin]
  );

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="CUstomer" breadcrumbItems={breadcrumbItems} />
        </div>

        <div className="card">
          <div className="card-body">
             {loading ? (
                <div className="text-center">Loading...</div>
              ) : customers.length > 0 ? (
                <TableContainer
                columns={columns || []}
                data={customers || []}
                isPagination={true}
                isGlobalFilter={true}
                customPageSize={pageSize}
                isAddOptions={isAdmin}
                addOptionTitle={"Add New Customer"}
                iscustomPageSize={false}
                isBordered={false}
                controlledPagination={{
                  pageIndex,
                  setPageIndex,
                  pageSize,
                  setPageSize,
                  totalPages,
                }}
                onSortChange={setSortBy}
                searchText={searchText}
                onSearchChange={handleSearchChange}
                handleAddClick={
                  isAdmin ? () => navigate("/add-customer") : undefined
                }
              />
              ) : (
                <div className="text-center py-5">
                  <h5>No Record Found</h5>
                  {/* {isAdmin && (
                    <Link to="/add-customer" className="btn btn-primary mt-3">
                      Add New Customer
                    </Link>
                  )} */}
                </div>
              )}
          </div>
        </div>
      </div>
      
      {/* Modal for delete confirmation */}
      {modalOpen && (
        <div className="modal fade show" style={{display: 'block'}}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Confirm Deletion</h5>
                <button type="button" className="btn-close" onClick={toggleModal}></button>
              </div>
              <div className="modal-body">
                Are you sure you want to delete this customer permanently?
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={toggleModal}>
                  Cancel
                </button>
                <button type="button" className="btn btn-danger" onClick={confirmDelete}>
                  Yes, Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      
      {/* Modal backdrop */}
      {modalOpen && <div className="modal-backdrop fade show"></div>}

      <EditCustomerModal
        isOpen={editModalOpen}
        toggle={() => setEditModalOpen(false)}
        customerData={selectedCustomer}
        onUpdated={() =>
          fetchCustomers(pageIndex, pageSize, sortBy, searchText)
        }
      />
    </React.Fragment>
  );
};

export default Customers;